import { Pipe, PipeTransform } from '@angular/core';
import { normalizePhoneNumber } from '@prism/prism-shared';

@Pipe({
    name: 'phoneNumber',
})

export class PhoneNumberPipe implements PipeTransform {
    // Phones are STORED as digit strings (see normalizePhoneNumber); this formats them
    // back out as (###) ###-####. Values saved pre-formatted normalize to the same 10
    // digits, so legacy data displays identically. Anything not recognizably a US
    // number (short, international) passes through untouched.
    transform(value: string | null | undefined): string {
        const raw = (value ?? '').trim();
        const digits = normalizePhoneNumber(raw);
        if (digits.length !== 10) return raw;
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
}
